import React, { useEffect } from 'react';

const MetaTagsHelper = ({ prismicPage }) => {
    useEffect(() => {
        const title = prismicPage.data.meta_title;
        const description = prismicPage.data.meta_description;
        const ogImage = prismicPage.data.og_image;
        const url = window.location.origin + window.location.pathname;

        if (title) document.title = title;
        if (description) updateMetaTag('description', description);

        // Open Graph tags (updates Yoast's server-rendered tags during SPA navigation)
        if (title) updateMetaTag('og:title', title, true);
        if (description) updateMetaTag('og:description', description, true);
        updateMetaTag('og:url', url, true);
        updateMetaTag('og:type', 'website', true);
        updateMetaTag('og:site_name', 'Cardcam', true);
        updateMetaTag('og:locale', 'sv_SE', true);

        if (ogImage) {
            updateMetaTag('og:image', ogImage, true);
            updateMetaTag('og:image:width', '1200', true);
            updateMetaTag('og:image:height', '630', true);
        }

        // Twitter Card tags
        updateMetaTag('twitter:card', 'summary_large_image');
        if (title) updateMetaTag('twitter:title', title);
        if (description) updateMetaTag('twitter:description', description);
        if (ogImage) updateMetaTag('twitter:image', ogImage);

    }, [prismicPage]);

    const updateMetaTag = (name, content, isProperty = false) => {
        const attr = isProperty ? 'property' : 'name';
        let element = document.querySelector(`meta[${attr}="${name}"]`);
        if (!element) {
            element = document.createElement('meta');
            element.setAttribute(attr, name);
            document.head.appendChild(element);
        }
        element.setAttribute('content', content);
    };

    return null;
};

export default MetaTagsHelper;
